export default {"src":"/_next/static/media/heart-solid-full.88e00dfc.svg","height":640,"width":640,"blurWidth":0,"blurHeight":0};